import { IframeMessage } from '@/constants/iframeMessages';
import type { ProductItem } from '@/types/order';
interface ErrorData {
  isFatal?: boolean;
  reason?: string;
}
interface PromoCodeData {
  name: string;
  discountAmount: number;
  discountPercentage: number;
}
interface EventData {
  orderId?: string;
  date?: string;
  sessionId?: string;
  bundleName?: string;
  bundleId?: string;
  bundleSKU?: string;
  products: ProductItem[];
  totalSum?: number;
  totalSumCurrency?: string;
  paymentMethodName?: string;
  userId?: string;
  userCountry?: string;
  reason?: string;
  isSavedPaymentMethodUsed?: boolean;
  isNewPaymentMethodSaved?: boolean;
  error?: ErrorData;
  promoCode: PromoCodeData | null;
}
interface MessageConfig {
  targetOrigin?: string;
  targetWindow?: Window;
}

class IframeMessenger {
  private targetOrigin: string;
  private targetWindow: Window;

  constructor(config?: MessageConfig) {
    this.targetOrigin = config?.targetOrigin ?? '*';
    this.targetWindow = config?.targetWindow ?? window.parent;
  }

  setTargetOrigin(origin: string): void {
    this.targetOrigin = origin;
  }

  setTargetWindow(target: Window): void {
    this.targetWindow = target;
  }

  postMessage(event: IframeMessage, eventData: EventData): void {
    try {
      this.targetWindow.postMessage({ event, params: eventData }, this.targetOrigin);
    } catch (error) {
      console.error('Failed to post message:', error);
      throw error;
    }
  }

  postMessageSafe(eventData: EventData): boolean {
    try {
      this.targetWindow.postMessage(eventData, this.targetOrigin);
      return true;
    } catch (error) {
      console.error('Failed to post message:', error);
      return false;
    }
  }
}

export const iframeMessenger = new IframeMessenger();

export { IframeMessenger };
export type { EventData, MessageConfig, ErrorData, PromoCodeData };
